import { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'
import ReactApexChart from 'react-apexcharts'
import { RootState } from '../../../../../setup'
import Pagination from '../../../components/Pagination'
import TooltipMaxLength from '../../../../hooks/utils/TooltipMaxLength'
import { AssignCreditsModel } from './AssignCreditModel'
import { getMyCredits, getMyPayments } from '../../../../services/loyaltyProgramService'
import { formatDateShortIntl2 } from '../../../../helpers/FormatDate'
import SVG from 'react-inlinesvg'

export const CreditsAndPaymentsWrapper: FC<{ userId: number }> = ({ userId }) => {
    const limit = 10;
    const history = useHistory()
    const subscription = useSelector(
        (state: RootState) => state.auth?.subscription,
        shallowEqual
    )
    const [currentMembership, setCurrentMembership] = useState<any | null>(null)

    const [receipts, setReceipts] = useState<PaymentHistory>([]);
    const [currentPagePayment, setCurrentPagePayment] = useState(1)
    const [paginationDataPayment, setPaginationDataPayment] = useState<any>(null);
    const totalPagesPayment = paginationDataPayment ? Math.ceil(paginationDataPayment.count / limit) : 1;

    const [credits, setCredits] = useState<CreditHistory>([]);
    const [currentPageCredits, setCurrentPageCredits] = useState(1)
    const [paginationDataCredits, setPaginationDataCredits] = useState<any>(null);
    const totalPagesCredits = paginationDataCredits ? Math.ceil(paginationDataCredits.count / limit) : 1;

    const [isOpenAssignModel, setIsOpenAssignModel] = useState(false);
    const [stats, setStats] = useState<LoyaltySummary | null>(null);

    const expiringText = `${stats?.expiringSoon?.credits || 0} credits is expiring on ${stats?.expiringSoon?.endDate ? formatDateShortIntl2(stats?.expiringSoon?.endDate) : ''}`

    useEffect(() => {
        getPayments()
        getCredits()
    }, [])

    const getPayments = async (page:number=1,offset:number=0) => {
        let payments = await getMyPayments({ user_id: userId, limit, offset})
        setPaginationDataPayment(payments);
        setReceipts(payments?.results || []);
        setCurrentPagePayment(page);
    }
   
    const getCredits = async (page:number=1,offset:number=0) => {
        let credits_ = await getMyCredits({ user_id: userId, limit, offset})
        setPaginationDataCredits(credits_);
        setCredits(credits_?.results || []);
        setStats(credits_?.stats || null);
        setCurrentMembership(credits_?.membership || {});
        setCurrentPageCredits(page);
    }

    const textRedeem = stats?.totalRedemptions ? 'redemptions' : 'Nothing'

    const chartOptions = {
        chart: { type: 'donut' },
        labels: ['Earnings', 'Expire', textRedeem],
        colors: ['#540008', '#ccc', '#eee'],
        legend: { show: false },
        dataLabels: { enabled: false },
    }

    const chartSeries = [stats?.totalEarnings || 0, stats?.totalExpiration || 0, stats?.totalRedemptions || 100]

    const handlePageChangePayment = async (page: number) => {
        const offset = (page - 1) * limit;
        await getPayments(page, offset);
    };
    
    const handlePageChangeCredits = async (page: number) => {
        const offset = (page - 1) * limit;
        await getCredits(page, offset);
    };

    return (
        <div className="financial-page-admin mt-6">
            <div className="financial-membership">
                <div className="financial-membership__container">
                    {/* ACTIVITY */}
                    <span className="financial-membership__label">
                        payment history
                    </span>
                    <div className="receipts-task-table">
                        <div className="receipts-task-table__header">
                            <div>Date</div>
                            <div>Item</div>
                            <div>Method</div>
                            <div>Beneficiary</div>
                            <div>Amount</div>
                            {/* <div>Action</div> */}
                        </div>
        
                        {receipts.map((row, index) => (
                            <div key={index} className="receipts-task-table__row">
                                <div className="receipts-task-table__cell">
                                    {formatDateShortIntl2(row.date)}
                                </div>
                                <div className="receipts-task-table__cell">
                                    <TooltipMaxLength
                                        text={row.item}
                                        maxLength={80}
                                        maxWidth={380}
                                        position="bottom"
                                    />
                                </div>
                                <div className="receipts-task-table__cell">
                                    {row.method}
                                </div>
                                <div className="receipts-task-table__cell">
                                    <span>{row.beneficiary}</span>
                                </div>
                                <div className="receipts-task-table__cell">
                                    {row.amount}
                                </div>
                                {/* <div className="receipts-task-table__cell">
                                    Action
                                </div> */}
                            </div>
                        ))}

                        <div className='tap-flex-center w-100 mt-4'>
                            <Pagination currentPage={currentPagePayment} totalPages={totalPagesPayment} onPageChange={handlePageChangePayment} />
                        </div>
                    </div>
                    {/* LOYALTY */}
                    <div className="financial-membership__section">
                        <div className='w-100 d-flex flex-row justify-content-between'>
                            <span className="financial-membership__label">
                                Credits history
                            </span>
                            <div className='financial-membership__cancel-subscription fs-6 text-bold' onClick={()=>setIsOpenAssignModel(true)}>
                                Assign credits
                            </div>
                        </div>
                        <div className="financial-membership__card">
                            <div className="financial-membership__loyalty-content">
                                {/* LEFT */}
                                <div className="left pr_4">
                                    <div className="w-100 financial-membership__credits">
                                        <ReactApexChart
                                            options={chartOptions}
                                            series={chartSeries}
                                            type="donut"
                                            height={220}
                                        />

                                        <div className="center-text pl_1">
                                            <span className="w-100">Available Credits</span>
                                            <strong className="w-100">{stats?.totalEarnings || 0}</strong>
                                            <span>
                                                <img src="/media/laurel-wreath.png" height={27} width={27} alt="" />
                                            </span>
                                        </div>
                                    </div>

                                    <div className="financial-membership__info">
                                        <div className="credits-info">
                                            <div className="credits-info__title">
                                                1 Credit = 1 USD <br />
                                                1 Year {currentMembership?.plan?.title} Membership Price - $ {currentMembership?.plan?.price}
                                            </div>

                                            <div className="credits-info__description">
                                                Credits can fully cover the cost of an {currentMembership?.plan?.title} Membership <br />
                                                for up to 3 years (75.000 Credits). <br />
                                                Any remaining balance may be paid in cash.
                                            </div>

                                            <div className="membership-contribution">
                                                <div className="membership-contribution__left">
                                                    <div className="membership-contribution__label">
                                                    Your {currentMembership?.plan?.title} Membership Contribution
                                                    </div>
                                                </div>

                                                <div className="membership-contribution__right">
                                                    <div className="membership-contribution__amount">
                                                    $ {currentMembership?.plan?.price}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className='financial-membership__cancel-subscription'>
                                                Cancel {currentMembership?.plan?.title}
                                            </div> */}

                                            <div className="credits-expiring">
                                                <div className="credits-expiring__text">
                                                {expiringText}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* RIGHT */}
                                <div className="right">
                                    <div className="financial-membership__history">
                                        <div className="financial-membership__row_header">
                                            <span>Date</span>
                                            <span>Description</span>
                                            <span>Credits</span>
                                        </div>

                                        {[...credits].map((credit: CreditHistoryItem, i) => (
                                            <div key={i} className="financial-membership__row">
                                                <span>{formatDateShortIntl2(credit.date)}</span>
                                                <span>{credit.description}</span>
                                                <span>{credit.credit}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='tap-flex-center w-100 mt-4'>
                                        <Pagination currentPage={currentPageCredits} totalPages={totalPagesCredits} onPageChange={handlePageChangeCredits} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AssignCreditsModel show={isOpenAssignModel} onClose={()=>setIsOpenAssignModel(false)} onSubmit={()=>setIsOpenAssignModel(true)} />
        </div>
    )
}

export type PaymentHistoryItem = {
  date: string;
  item: string;
  method: string;
  beneficiary: string;
  amount: number;
  currency: string;
};

export type PaymentHistory = PaymentHistoryItem[];

export type CreditHistoryItem = {
  date: string;
  description: string;
  credit: number;
};

export type CreditHistory = CreditHistoryItem[];

export type LoyaltySummary = {
  totalCredits: number;
  totalEarnings: number;
  totalRedemptions: number;
  totalExpiration: number;
  expiringSoon:{
    endDate: string;
    credits: number;
  }
};